export default __webpack_public_path__ + "static/media/im1.4442cfef.jpg";